import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<'openLinkInNewTab' | 'googleCalendarProvider', MessageDescriptor> =
	defineMessages({
		openLinkInNewTab: {
			id: 'rovo-platform-ui-components.insight-link-card.open-link-in-new-tab',
			defaultMessage: 'Open link in a new tab',
			description: 'Accessible label for opening an insight link card in a new browser tab',
		},
		googleCalendarProvider: {
			id: 'rovo-platform-ui-components.insight-link-card.google-calendar-provider',
			defaultMessage: 'Calendar',
			description: 'Accessible label for the Google Calendar icon',
		},
	});

export default messages;
